import React, { Component } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import Picker from 'react-mobile-picker'
import { dayData, EMPTY_ARRAY, EMPTY_OBJECT, hoursData, minutesData } from '../constants/globalConstants'
import { Row } from 'react-bootstrap'
import { formatDecimal } from '../utils/helper'
require('./ReactMobiltySpinner.scss')

class ReactMobiltySpinner extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dayValueGroups: { day: 0 },
            dayOptionGroups: { day: dayData },
            hourValueGroups: { hour: 0 },
            hourOptionGroups: { hour: hoursData },
            minuteValueGroups: { minute: 0 },
            minuteOptionGroups: { minute: minutesData },
            rateBandsValues: { rateBands: 0 },
            bandIndex: 0,
            rateBands: this.props.rateBands
        }
    }
    handleChange = (name, value) => {
        const { handleTimeLength } = this.props
        const e = { target: { 'name': [name], 'value': [value] } }
        if (name === 'day') {
            this.setState(({ dayValueGroups }) => ({ dayValueGroups: { ...dayValueGroups, [name]: value } }))
            handleTimeLength(e, 'day')
        } else if (name === 'hour') {
            this.setState(({ hourValueGroups }) => ({ hourValueGroups: { ...hourValueGroups, [name]: value } }))
            handleTimeLength(e, 'hour')
        } else if (name === 'minute') {
            this.setState(({ minuteValueGroups }) => ({ minuteValueGroups: { ...minuteValueGroups, [name]: value } }))
            handleTimeLength(e, 'minute')
        } else if (name === 'rateBands') {
            this.setState(({ rateBandsValues }) => ({ rateBandsValues: { ...rateBandsValues, [name]: value } }))
            handleTimeLength(e, 'rateBands')
        }
    }

    cliclRateBand = (e, band = [], ind) => {
        this.setState({bandIndex: ind+1})
        this.handleChange(Object.keys(e)[0], band?.rateBands[ind])
        this.props.setIsRateBandSelected(true)
        this.props.setselctedDateTime({...this.props.selctedDateTime, bandActive: false})
        if(this.props.warning) {
            this.props.SetstEndCalendar({...this.props.stEndCalendar, end_date: null })
        }
    }

    handleUpKey = (e, num, band = []) => {
        if(this.state.bandIndex >= 0 && this.state.bandIndex < band?.rateBands?.length - 2){
            this.setState({bandIndex: this.state.bandIndex + 1})
        }else{
            this.setState({bandIndex: this.state.bandIndex})
        }
        let add = num
        if (e[Object.keys(e)] == 31 || e[Object.keys(e)] == 23 || e[Object.keys(e)] == 45) {
            add = 0
        }
        if(Object.keys(e)[0] == 'rateBands'){
            if(this.state.bandIndex >= 0 && this.state.bandIndex < band?.rateBands?.length){
                this.handleChange(Object.keys(e)[0], band?.rateBands[this.state.bandIndex + 1])
            }
        }else{
            this.handleChange(Object.keys(e)[0], e[Object.keys(e)] + add)
        }
        
    }
    handleUpDownKey = (e, num, band = []) => {
        if(this.state.bandIndex > 0 && this.state.bandIndex <= band?.rateBands?.length - 2){
            this.setState({bandIndex: this.state.bandIndex - 1})
        }

        let sub = num
        if (e[Object.keys(e)] == 0) {
            sub = 0
        }
        if(Object.keys(e)[0] == 'rateBands'){
            if(this.state.bandIndex >= 0 && this.state.bandIndex <= band?.rateBands?.length){
                this.handleChange(Object.keys(e)[0], band?.rateBands[this.state.bandIndex])
            }
        }else{
            this.handleChange(Object.keys(e)[0], e[Object.keys(e)] - sub)
        }
        
    }
    hourselections = {
        hour: hoursData,
        //hour: [0,1,2,3]
    }
    minuteselections = {
        minute: minutesData,
        //hour: [0,1,2,3]
    }
    dayselections = {
        day: dayData,
        //hour: [0,1,2,3]
    }
    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.rateBands !== prevProps.rateBands) {
          this.setState({
            rateBands: this.props.rateBands
          })
        }
    }
    render() {
        const {
            dayValueGroups,
            // dayOptionGroups,
            hourValueGroups,
            // hourOptionGroups,
            // minuteOptionGroups,
            minuteValueGroups,
            rateBandsValues,
            rateBands
        } = this.state
        const { isMultiParking, isRateBand, rateBandData } = this.props
        return (
            <div className="p-0 m-0">
                {isRateBand ?
                    <Row className='p-0 m-0 d-flex justify-content-center align-items-center'>
                        {/* <div className='border border-2 rounded border-primary m-2 pb-3 pt-2'>
                            <Picker optionGroups={rateBands} valueGroups={rateBandsValues} onChange={this.handleChange} wheel='normal' className='text-black fw-bold w-100' />
                            <Row className='ms-1 text-end arrowContainer'>
                                <i className="fa fa-caret-up text-black " aria-hidden="true"
                                    onClick={() => { this.handleUpKey(rateBandsValues, 1, rateBands) }}
                                // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                ></i>
                                <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                    // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                    onClick={() => this.handleUpDownKey(rateBandsValues, 1, rateBands)}
                                ></i>
                            </Row>
                        </div> */}
                        {rateBands?.rateBands?.length > 0 && rateBands.rateBands.map((rate, index) => 
                        <div onClick={() => { this.cliclRateBand(rateBandsValues, rateBands, index) }} 
                            key={'rate_'+index} 
                            className={`${((this.state.bandIndex && (this.state.bandIndex - 1 === index) && this.props.isRateBandSelected)) ? 
                            'border-primary' : 'border-grey'} border border-2 rounded m-2 pb-2 pt-2`}>
                            <div className={`${(rateBandData.length > index && rateBandData[index]?.category_id == '316') ? 'pb-0' : 'pb-1'} pt-1 d-flex justify-content-between`}>
                                {rate} <span>${formatDecimal(rateBands?.price[index])}</span>
                            </div>
                            {(rateBandData.length > index && rateBandData[index]?.category_id == '316') ? <div className='sub-label small text-muted'><small>{rateBandData[index]?.open_time_description} - {rateBandData[index]?.exit_time_details}</small></div> : ''}
                        </div>
                        )
                        }
                    </Row>
                    : <Row className='p-0 d-flex justify-content-center align-items-center'>
                        {(isMultiParking) &&
                            <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3 '>
                                <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Days</p>
                                {/* <Picker optionGroups={dayOptionGroups} valueGroups={dayValueGroups} onChange={this.handleChange} wheel='normal' /> */}
                                <Picker wheel="natural"
                                    value={dayValueGroups}
                                    // option={dayValueGroups}
                                    height={42}
                                    onChange={(e) => {
                                        this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                    }}
                                    className='mobi-scroll-border-0'
                                >
                                    {Object.keys(this.dayselections).map(name => (
                                        <Picker.Column key={name} name={name}>
                                            {this.dayselections[name].map(option => (
                                                <Picker.Item key={option} value={option}>
                                                    {option}
                                                </Picker.Item>
                                            ))}
                                        </Picker.Column>
                                    ))}
                                
                                </Picker>
                                <Row className='ms-1 text-end arrowContainer'>

                                    <i className="fa fa-caret-up text-black " aria-hidden="false"
                                        onClick={() => { this.handleUpKey(dayValueGroups, 1) }}
                                    // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                    ></i>
                                    <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                        // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                        onClick={() => this.handleUpDownKey(dayValueGroups, 1)}
                                    ></i>
                                </Row>
                            </div>
                        }

                        <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3'>
                            <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Hours</p>
                            {/* <Picker optionGroups={hourOptionGroups} valueGroups={hourValueGroups} onChange={this.handleChange} wheel='normal' className='text-black fw-bold' /> */}
                            <Picker wheel="natural"
                                value={hourValueGroups}
                                // option={hourValueGroups}
                                height={42}
                                onChange={(e) => {
                                    this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                }}
                                className='mobi-scroll-border-0'
                            >
                                {Object.keys(this.hourselections).map(name => (
                                    <Picker.Column key={name} name={name}>
                                        {this.hourselections[name].map(option => (
                                            <Picker.Item key={option} value={option}>
                                                {option}
                                            </Picker.Item>
                                        ))}
                                    </Picker.Column>
                                ))}
                            
                            </Picker>
                            <Row className='ms-1 text-end arrowContainer'>
                                <i className="fa fa-caret-up text-black " aria-hidden="true"
                                    onClick={() => { this.handleUpKey(hourValueGroups, 1) }}
                                // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                ></i>
                                <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                    // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                    onClick={() => this.handleUpDownKey(hourValueGroups, 1)}
                                ></i>
                            </Row>
                        </div>
                        <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3'>
                            <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Minutes</p>
                            {/* <Picker optionGroups={minuteOptionGroups} valueGroups={minuteValueGroups} onChange={this.handleChange} wheel='normal' /> */}
                            <Picker wheel="natural"
                                value={minuteValueGroups}
                                // option={minuteValueGroups}
                                height={42}
                                onChange={(e) => {
                                    this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                }}
                                className='mobi-scroll-border-0'
                            >
                                {Object.keys(this.minuteselections).map(name => (
                                    <Picker.Column key={name} name={name}>
                                        {this.minuteselections[name].map(option => (
                                            <Picker.Item key={option} value={option}>
                                                {option}
                                            </Picker.Item>
                                        ))}
                                    </Picker.Column>
                                ))}
                            
                            </Picker>
                            <Row className='ms-1 text-end arrowContainer'>
                                <i className="fa fa-caret-up text-black " aria-hidden="true"
                                    onClick={() => { this.handleUpKey(minuteValueGroups, 15) }}>

                                </i>
                                <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                    onClick={() => this.handleUpDownKey(minuteValueGroups, 15)}></i>
                            </Row>
                        </div>
                    </Row>}
            </div>
        )
    }
}

ReactMobiltySpinner.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isMultiParking: PropTypes.bool,
    handleTimeLength: PropTypes.func,
    currDays: PropTypes.number,
    currHour: PropTypes.number,
    currMin: PropTypes.number,
    isRateBand: PropTypes.bool,
    rateBands: PropTypes.array,
    isRateBandSelected: PropTypes.bool,
    setIsRateBandSelected: PropTypes.func,
    setselctedDateTime: PropTypes.func,
    selctedDateTime: PropTypes.object,
    rateBandData: PropTypes.array,
    SetstEndCalendar: PropTypes.func,
    stEndCalendar: PropTypes.object,
    warning: PropTypes.bool
}

ReactMobiltySpinner.defaulProps = {
    dispatch: noop,
    loader: true,
    isMultiParking: false,
    handleTimeLength: noop,
    currDays: 0,
    currHour: 0,
    currMin: 0,
    isRateBand: false,
    rateBands: EMPTY_ARRAY,
    isRateBandSelected: true,
    setIsRateBandSelected: noop,
    setselctedDateTime: noop,
    selctedDateTime: EMPTY_OBJECT,
    rateBandData: EMPTY_ARRAY,
    SetstEndCalendar: noop,
    stEndCalendar: EMPTY_OBJECT,
    warning: false
}

function mapStateToProps({ transientReducer, PaymentReducer, VehilceReducer }) {
    const { data } = VehilceReducer

    return {
        loader: transientReducer?.loader,
        isFetching: transientReducer?.isFetching,
        cards: PaymentReducer?.data?.data,
        vehicleDataList: data?.data
    }
}

export default connect(mapStateToProps)(ReactMobiltySpinner)